var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "archive panel panel-right",
      class: { hidden: !_vm.visible }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "bar",
              rawName: "v-bar",
              value: {
                preventParentScroll: true,
                overrideFloatingScrollbar: false
              },
              expression:
                "{ preventParentScroll: true, overrideFloatingScrollbar: false }"
            }
          ]
        },
        [
          _c(
            "div",
            _vm._l(_vm.films, function(film) {
              return _c(
                "div",
                {
                  key: film.id,
                  staticClass: "archive-item",
                  class: {
                    active:
                      _vm.$route.params && _vm.$route.params.slug == film.slug
                  }
                },
                [
                  _c(
                    "router-link",
                    { attrs: { tabindex: "-1", to: "/film/" + film.slug } },
                    [
                      _c("span", { staticClass: "photo-aspect-wrapper" }, [
                        _c("div", {
                          staticClass: "thumbnail",
                          style: {
                            backgroundImage: "url(" + film.thumbnail + ")"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "box-aspect-wrapper" }, [
                        _c("span", { staticClass: "number" }, [
                          _vm._v(_vm._s(_vm.zeroPad(film.number, 2)))
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            }),
            0
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }